import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { TeamCommentPayload } from '@/api/v4/team-comments.api';
import { createTeamComment } from '@/api/v4/team-comments.api';
import { notify } from '@/ui/snackbar/notify';
import { QueryKey } from '@/config/query-client';

type CreateTeamCommentMutationParams = {
  teamId: string;
  payload: TeamCommentPayload;
};

export const useCreateTeamComment = () => {
  const { t } = useTranslation('default');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      teamId,
      payload,
    }: CreateTeamCommentMutationParams) => {
      return createTeamComment(teamId, payload);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamComments, variables.teamId],
      });
    },
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      captureException(error);
    },
  });
};
